import { NgModule, LOCALE_ID } from '@angular/core';
import { DatePipe, registerLocaleData } from '@angular/common';
import {
  HTTP_INTERCEPTORS,
  HttpClient,
  provideHttpClient,
  withInterceptorsFromDi,
} from '@angular/common/http';
import { Title } from '@angular/platform-browser';
import { FaIconLibrary } from '@fortawesome/angular-fontawesome';
import { CookieService } from 'ngx-cookie-service';
import { TranslateModule, TranslateLoader, MissingTranslationHandler } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import {
  provideNgxWebstorage,
  withNgxWebstorageConfig,
  withLocalStorage,
  withSessionStorage,
} from 'ngx-webstorage';
import { MessageService } from 'primeng/api';
import locale from '@angular/common/locales/en';
import dayjs from 'dayjs';
import { NgbDateAdapter, NgbDatepickerConfig } from '@ng-bootstrap/ng-bootstrap';
import { NgbDateDayjsAdapter } from '../shared/util/datepicker-adapter';
import { fontAwesomeIcons } from './icons/font-awesome-icons';
import { AuthInterceptor } from '../blocks/interceptor/auth.interceptor';
import { AuthExpiredInterceptor } from '../blocks/interceptor/auth-expired.interceptor';
import { ErrorHandlerInterceptor } from '../blocks/interceptor/errorhandler.interceptor';
import { NotificationInterceptor } from '../blocks/interceptor/notification.interceptor';
import { DateFixHttpInterceptor } from '../blocks/interceptor/date-fix.interceptor';
import { MyMissingTranslationHandler } from './language/missingTranslationHandler';
import { providePrimeNG } from 'primeng/config';
import Material from '@primeng/themes/material';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { Language } from './language/language.constants';
import { GlobalErrorHandlerService } from './error-handler/global-error-handler.service';
import { ErrorHandler } from '@angular/core';

@NgModule({
  imports: [
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
      defaultLanguage: Language.SR,
      useDefaultLang: true,
      missingTranslationHandler: {
        provide: MissingTranslationHandler,
        useClass: MyMissingTranslationHandler,
      },
    }),
  ],
  providers: [
    Title,
    CookieService,
    MessageService,
    provideAnimationsAsync(),
    providePrimeNG({
      theme: {
        preset: Material,
      },
    }),
    {
      provide: LOCALE_ID,
      useValue: Language.EN,
    },
    { provide: NgbDateAdapter, useClass: NgbDateDayjsAdapter },
    DatePipe,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthExpiredInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ErrorHandlerInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: NotificationInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: DateFixHttpInterceptor,
      multi: true,
    },
    provideNgxWebstorage(
      withNgxWebstorageConfig({
        prefix: 'benefit',
        separator: '-',
      }),
      withLocalStorage(),
      withSessionStorage()
    ),
    provideHttpClient(withInterceptorsFromDi()),
    {
      provide: ErrorHandler,
      useClass: GlobalErrorHandlerService,
    },
  ],
})
export class CoreModule {
  constructor(iconLibrary: FaIconLibrary, dpConfig: NgbDatepickerConfig) {
    registerLocaleData(locale);
    iconLibrary.addIcons(...fontAwesomeIcons);
    dpConfig.minDate = { year: dayjs().year() - 100, month: 1, day: 1 };
    // languageService.init();
  }
}

export function HttpLoaderFactory(http: HttpClient): TranslateHttpLoader {
  return new TranslateHttpLoader(http, '/assets/locales/', '.json');
}
